interface Props {
  clientes: string[];
  clienteSelecionado: string;
  onClienteChange: (v: string) => void;
  refreshSec: number;
  onRefreshSecChange: (v: number) => void;
  onRefreshNow: () => void;
}

export function FiltrosBar({
  clientes,
  clienteSelecionado,
  onClienteChange,
  refreshSec,
  onRefreshSecChange,
  onRefreshNow,
}: Props) {
  return (
    <div className="filtros-bar">
      <label htmlFor="f-cliente">Cliente</label>
      <select
        id="f-cliente"
        value={clienteSelecionado}
        onChange={(e) => onClienteChange(e.target.value)}
      >
        <option value="TODOS">TODOS</option>
        {clientes.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>

      <span style={{ flex: 1 }} />

      <label htmlFor="f-refresh">Auto-refresh</label>
      <select
        id="f-refresh"
        value={refreshSec}
        onChange={(e) => onRefreshSecChange(Number(e.target.value))}
      >
        <option value={0}>Manual</option>
        <option value={10}>10s</option>
        <option value={30}>30s</option>
        <option value={60}>60s</option>
        <option value={300}>5min</option>
      </select>
      <button className="btn-refresh" onClick={onRefreshNow}>
        🔄 Atualizar agora
      </button>
    </div>
  );
}
